export const COLORS = {
  // Base colors
  base: {
    white: '#FFFFFF',
    black: '#131122',
  },

  // Primary brand colors
  primary: {
    25: '#F5F6FF',
    50: '#EDF0FF',
    100: '#DEE4FF',
    200: '#C3CCFF',
    300: '#9FAAFF',
    400: '#797DFF',
    500: '#605AFB', // Main brand color
    600: '#503BF0',
    700: '#442ED4',
    800: '#3828AB',
    900: '#322887',
    950: '#1E184E',
  },

  // Secondary (previously grey) colors
  secondary: {
    25: '#F8F9FC',
    50: '#F3F4F9',
    100: '#E9EBF4',
    200: '#D7DAEB',
    300: '#BFC3DF',
    400: '#A6A7D2',
    500: '#9998BD',
    600: '#847EAD',
    700: '#6D659D',
    800: '#585281',
    900: '#413B74',
    950: '#262244',
  },

  // State/Status colors for UI feedback
  status: {
    success: '#4FD08A',
    warning: '#FAA238',
    error: '#DC3636',
    info: '#605AFB',
  },

  // Feedback colors with variations
  success: {
    light: '#A4F4E7',
    default: '#15B097',
    dark: '#0B7B69',
  },
  warning: {
    light: '#F4C790',
    default: '#EDA145',
    dark: '#CC7914',
  },
  error: {
    light: '#E4626F',
    default: '#C03744',
    dark: '#8C1823',
  },

  // border color
  border: {
    color: '#E9EBF4',
  },

  'pastel-1': {
    light: '#FFEBE5',
    dark: '#CC2900',
  },
  'pastel-2': {
    light: '#E3F7EB',
    dark: '#227743',
  },
  'pastel-3': {
    light: '#F0E7FE',
    dark: '#680AF5',
  },
  'pastel-4': {
    light: '#EAF4FA',
    dark: '#1E587B',
  },
  'pastel-5': {
    light: '#F3F4F9',
    dark: '#585281',
  },
  'pastel-6': {
    light: '#FEEACD',
    dark: '#4D0F00',
  },
  'pastel-7': {
    light: '#E3F2FD',
    dark: '#0D47A1',
  },
  'pastel-8': {
    light: '#FCE4EC',
    dark: '#880E4F',
  },
  'pastel-9': {
    light: '#FFFDE7',
    dark: '#7A6000',
  },
  'pastel-10': {
    light: '#FDF6E3',
    dark: '#B58900',
  },
} as const;
